import { array, ord, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Order } from '@optimus-web/core';
import { GeneralEnterpriseWithCityName } from './types';

export const getFilteredProperties = ({
    data,
    nameSearchTerm,
    cityNameSearchTerm,
    nameSortOrder,
    cityNameSortOrder,
}: {
    data: GeneralEnterpriseWithCityName[];
    nameSearchTerm?: string;
    cityNameSearchTerm?: string;
    nameSortOrder?: Order;
    cityNameSortOrder?: Order;
}) => {
    const filteredData =
        nameSearchTerm || cityNameSearchTerm
            ? data.filter(
                  ({ name, cityName }) =>
                      name.toLowerCase().includes(nameSearchTerm?.toLowerCase() || '') &&
                      cityName?.toLowerCase().includes(cityNameSearchTerm?.toLowerCase() || '')
              )
            : data;

    if (nameSortOrder == null && cityNameSortOrder == null) {
        return filteredData;
    }

    if (nameSortOrder) {
        const orderByName: ord.Ord<GeneralEnterpriseWithCityName> = pipe(
            nameSortOrder === Order.Descending ? ord.reverse(string.Ord) : string.Ord,
            ord.contramap(({ name }) => name.toLowerCase())
        );

        return array.sortBy([orderByName])(filteredData);
    }

    if (cityNameSortOrder) {
        const orderByCityName: ord.Ord<GeneralEnterpriseWithCityName> = pipe(
            cityNameSortOrder === Order.Descending ? ord.reverse(string.Ord) : string.Ord,
            ord.contramap(({ cityName }) => cityName?.toLowerCase() || '')
        );

        return array.sortBy([orderByCityName])(filteredData);
    }

    return filteredData;
};
